// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/Images/pattern-background-lines.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.top-wrap {
    width: 100%;
    display: flex;
    background-color: #fff;
    justify-content: center;
  }
  
  .GraphContainer{
    align-items: center;
    width: 100%;
    background-color: #F4F4F4;
    max-height: calc(100vh - 116px);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    overflow-y: scroll
  }
  
  .GraphHeading {
    background-color: #f5f8ff;
    padding: 19px 16px;
    font-weight: bold;
    text-align: left;
    font-weight: 700;
    font-size: 14px;
  }
  
  .single-graph-wrapper {
    border-radius: 8px;
    background-color: #fff;
    margin: 20px;
    padding-bottom: 15px;
  }
  
  .remarks{
    font-weight: 700;
    font-size: 14px;
    padding: 8px 16px;
    border: 1px solid grey;
    text-align: left;
    color: #fe5353;
    margin-top: 0px;
    margin: 0 20px;
    border-radius: 8px;
    margin-bottom: 30px;
  }
  
  .satisfactory{
    color: black;
  }
  .satisfactory:before{
   content: "✱";
    color: black;
  }
  .notsatisfactory:before{
    content: "✱";
    color: #fe5353;
  }
    
  
  .notsatisfactory{
    color: #fe5353;
    background-color: #fff5f5;
    border: 1px solid #f5e1e1;
  }

  .graph-filters-wrap {
    padding: 10px;
  }

  .graph-filter-item {
    padding: 4px 8px;
    color: #477afe;
    font-family: 'IBM-Plex-sans-semibold';
    font-size: 14px;
    border: 1px solid #a0b4eb;
    border-radius: 13px;
    background-color: #eaeffe;
    margin: 5px 10px;
    cursor: pointer;
  }

  .graph-filter-item.selected {
    color: #fff;
    background-color: #477afe;
  }

  .circuit-filter {
    background: #477AFE;
    color: #fff;
    margin: 6px 0;
    font-size: 14px;
    border: none;
    border-radius: 4px;
    padding: 4px 12px;
  }

  .circuit-filter-wrap {
    display: flex;
    flex-direction: row-reverse;
  }

  .phases-filter-wrap {
    display: flex;
    flex-flow: wrap;
    max-width: 100%;
  }
`, "",{"version":3,"sources":["webpack://./src/components/Charts/GraphParent.css"],"names":[],"mappings":";AACA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,+BAA+B;IAC/B,yDAAiE;IACjE;EACF;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;EACA;GACC,YAAY;IACX,YAAY;EACd;EACA;IACE,YAAY;IACZ,cAAc;EAChB;;;EAGA;IACE,cAAc;IACd,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,qCAAqC;IACrC,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,eAAe;IACf,eAAe;EACjB","sourcesContent":["\n.top-wrap {\n    width: 100%;\n    display: flex;\n    background-color: #fff;\n    justify-content: center;\n  }\n  \n  .GraphContainer{\n    align-items: center;\n    width: 100%;\n    background-color: #F4F4F4;\n    max-height: calc(100vh - 116px);\n    background-image: url(\"/src/Images/pattern-background-lines.svg\");\n    overflow-y: scroll\n  }\n  \n  .GraphHeading {\n    background-color: #f5f8ff;\n    padding: 19px 16px;\n    font-weight: bold;\n    text-align: left;\n    font-weight: 700;\n    font-size: 14px;\n  }\n  \n  .single-graph-wrapper {\n    border-radius: 8px;\n    background-color: #fff;\n    margin: 20px;\n    padding-bottom: 15px;\n  }\n  \n  .remarks{\n    font-weight: 700;\n    font-size: 14px;\n    padding: 8px 16px;\n    border: 1px solid grey;\n    text-align: left;\n    color: #fe5353;\n    margin-top: 0px;\n    margin: 0 20px;\n    border-radius: 8px;\n    margin-bottom: 30px;\n  }\n  \n  .satisfactory{\n    color: black;\n  }\n  .satisfactory:before{\n   content: \"✱\";\n    color: black;\n  }\n  .notsatisfactory:before{\n    content: \"✱\";\n    color: #fe5353;\n  }\n    \n  \n  .notsatisfactory{\n    color: #fe5353;\n    background-color: #fff5f5;\n    border: 1px solid #f5e1e1;\n  }\n\n  .graph-filters-wrap {\n    padding: 10px;\n  }\n\n  .graph-filter-item {\n    padding: 4px 8px;\n    color: #477afe;\n    font-family: 'IBM-Plex-sans-semibold';\n    font-size: 14px;\n    border: 1px solid #a0b4eb;\n    border-radius: 13px;\n    background-color: #eaeffe;\n    margin: 5px 10px;\n    cursor: pointer;\n  }\n\n  .graph-filter-item.selected {\n    color: #fff;\n    background-color: #477afe;\n  }\n\n  .circuit-filter {\n    background: #477AFE;\n    color: #fff;\n    margin: 6px 0;\n    font-size: 14px;\n    border: none;\n    border-radius: 4px;\n    padding: 4px 12px;\n  }\n\n  .circuit-filter-wrap {\n    display: flex;\n    flex-direction: row-reverse;\n  }\n\n  .phases-filter-wrap {\n    display: flex;\n    flex-flow: wrap;\n    max-width: 100%;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
